import React from 'react';

import './Diablo4Leveling.sass';

import {injectIntl} from 'react-intl';
import withMediaQueries from '../../../../containers/withMediaQueries/withMediaQueries';
import VariableStepRange from '../../../controls/variableStepRange/VariableStepRange';
import RestrictedNumberInput from '../../../controls/restrictedNumberInput/RestrictedNumberInput';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 767px)'}, {collapsed: false})
export default class Diablo4SeasonOfDiscoveryLevelingRankPicker extends React.PureComponent {
  static describeRank = rank => rank.toString();

  static minValue = 1;
  static maxValue = 25;

  static getDefaultValue = () => [1, 10];

  static marks = {
    1: '1',
    5: '5',
    10: '10',
    15: '15',
    20: '20',
    25: '25',
  };

  render() {
    const {intl, collapsed, value, onChange} = this.props;

    return (
      <div>
        <div className="range-inputs">
          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.level'})}
              min={Diablo4SeasonOfDiscoveryLevelingRankPicker.minValue}
              max={Diablo4SeasonOfDiscoveryLevelingRankPicker.maxValue}
              value={value[0]}
              onChange={newValue => onChange([
                newValue,
                value[1]
              ])}
            />
          </div>

          <div className="range-inputs__divider"/>

          <div className="range-inputs__item">
            <RestrictedNumberInput
              label={intl.formatMessage({id: 'section.product.wanted'})}
              min={Diablo4SeasonOfDiscoveryLevelingRankPicker.minValue}
              max={Diablo4SeasonOfDiscoveryLevelingRankPicker.maxValue}
              value={value[1]}
              onChange={newValue => onChange([
                value[0],
                newValue
              ])}
            />
          </div>
        </div>

        {!collapsed && (
          <div className="slider">
            <VariableStepRange
              className="rc-slider-diablo-leveling"
              step={1}
              min={Diablo4SeasonOfDiscoveryLevelingRankPicker.minValue}
              max={Diablo4SeasonOfDiscoveryLevelingRankPicker.maxValue}
              marks={Diablo4SeasonOfDiscoveryLevelingRankPicker.marks}
              value={value}
              onChange={onChange}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/productVariants/rankPickers/diablo4Leveling/Diablo4SeasonOfDiscoveryLeveling.js